import { React, useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
} from "@chakra-ui/react";

import { Button, ButtonGroup } from "@chakra-ui/react";
import { useDisclosure } from "@chakra-ui/react";
import {
  FormControl,
  FormLabel,
  FormErrorMessage,
  FormHelperText,
} from "@chakra-ui/react";
import { Input } from "@chakra-ui/react";

const BlockUser = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const initial = {
    name: "",
    id: "",
  };

  const [event, setEvent] = useState(initial);
  const handleChange = (e) => {
    setEvent({ ...event, [e.target.name]: e.terget.value });
  };

  const handleSubmit = () => {};

  return (
    <>
      <Button onClick={onOpen}>Block User</Button>

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Block User</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <FormControl>
              <FormLabel>Name</FormLabel>
              <Input
                type="email"
                name="name"
                onChange={(e) => {
                  handleChange(e);
                }}
              />

              <FormLabel>User ID</FormLabel>
              <Input
                type="text"
                name="id"
                onChange={(e) => {
                  handleChange(e);
                }}
              />

              <Button
                mt={4}
                colorScheme="teal"
                type="submit"
                onClick={handleSubmit}
              >
                Submit
              </Button>
            </FormControl>
          </ModalBody>
          <ModalFooter style={{ padding: "2rem" }}>
            <Button colorScheme="blue" mr={3} onClick={onClose}>
              Close
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default BlockUser;
